/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppService } from '@generated/services';
import { CONFIG } from '@web/core/injection-tokens/config.token';
import { patchPrimeNgTableResizeReorder } from '@web/shared/components/table/primeng-table-resize-reorder.fix';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

patchPrimeNgTableResizeReorder();

const doBootstrap = async () => {
  const res = await fetch(`${environment.api.basePath}${AppService.GetConfigPath}`);
  return await res.json();
};

doBootstrap().then((config) => {
  bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [
      ...appConfig.providers,
      {
        provide: CONFIG,
        useValue: config,
      },
    ],
  }).catch((err) => console.error(err));
});
